var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 34,
    viewBox: "0 0 46 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.132812 2.41113C0.132812 1.30656 1.02824 0.411133 2.13281 0.411133H15.7477C16.4025 0.411133 17.0159 0.731671 17.3897 1.26926L18.2927 2.56774C18.6666 3.10534 19.2799 3.42588 19.9347 3.42588H36.8011C37.9057 3.42588 38.8011 4.32131 38.8011 5.42588V31.8446C38.8011 32.9492 37.9057 33.8446 36.8011 33.8446H0.132812V2.41113Z",
    fill: "#F3B053"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0878906 33.8919H37.6522C38.5471 33.8919 39.3332 33.2974 39.5767 32.4361L45.8529 10.2415C46.2138 8.96503 45.2548 7.69727 43.9283 7.69727H32.1869C31.5764 7.69727 30.9994 7.9761 30.62 8.4544L29.3519 10.0531C28.9725 10.5314 28.3955 10.8102 27.785 10.8102H8.14771C7.25337 10.8102 6.46773 11.404 6.22364 12.2644L0.0878906 33.8919Z",
    fill: "#FBD984"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.ec7a3781c103b6df21ca38e9daff3579.svg";
export { ForwardRef as ReactComponent };